import { Builder } from "@builder.io/react";
import { DottedTooltip } from "@faire/web--source/retailer-components/DottedTooltip/DottedTooltip";
export var registerBuilderDottedTooltip = function() {
    Builder.registerComponent(DottedTooltip, {
        name: "DottedTooltip",
        hideFromInsertMenu: false,
        inputs: [
            {
                name: "text",
                type: "string",
                defaultValue: "Copy to be hovered over",
                localized: true
            },
            {
                name: "tooltipTitle",
                type: "string",
                defaultValue: "Title of the tooltip",
                localized: true
            },
            {
                name: "tooltipText",
                type: "string",
                defaultValue: "Tooltip description",
                localized: true
            },
            {
                name: "tooltipCTA",
                type: "string",
                defaultValue: "Tooltip CTA, e.g. Learn more",
                localized: true
            },
            {
                name: "tooltipCTALink",
                type: "string",
                defaultValue: "Tooltip CTA Link"
            },
            {
                name: "width",
                type: "number",
                defaultValue: 350
            },
            {
                name: "position",
                type: "string",
                defaultValue: "top",
                enum: [
                    "top",
                    "left",
                    "right",
                    "bottom"
                ]
            }
        ]
    });
};
